module.exports = __webpack_public_path__ + "static/media/DSC00182.e0ba1c89.jpg";